module.exports = __webpack_public_path__ + "static/media/arrow-left.39e709eb.svg";